/**
 * Format a timestamp as relative time (e.g., "Just now", "30 min ago", "Yesterday")
 */
export function formatRelativeTime(timestamp: string | null | undefined): string {
  if (!timestamp) return '';

  const now = new Date();

  // Bare datetime (YYYY-MM-DD HH:MM:SS) has no timezone — treat as UTC.
  let dateString = timestamp;
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timestamp)) {
    dateString = timestamp.replace(' ', 'T') + 'Z';
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    console.warn('[formatRelativeTime] Invalid date:', timestamp);
    return '';
  }

  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) {
    return 'Just now';
  }

  if (diffMin < 60) {
    return diffMin === 1 ? '1 min ago' : `${diffMin} min ago`;
  }

  if (diffHour < 24) {
    return diffHour === 1 ? '1 hour ago' : `${diffHour} hours ago`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  ) {
    return 'Yesterday';
  }

  if (diffDay < 7) {
    return `${diffDay} days ago`;
  }

  if (diffDay < 14) {
    return 'Last week';
  }

  const diffWeek = Math.floor(diffDay / 7);
  if (diffDay < 30) {
    return diffWeek === 2 ? '2 weeks ago' : `${diffWeek} weeks ago`;
  }

  const diffMonth = Math.floor(diffDay / 30);
  if (diffDay < 365) {
    return diffMonth === 1 ? '1 month ago' : `${diffMonth} months ago`;
  }

  const diffYear = Math.floor(diffDay / 365);
  return diffYear === 1 ? '1 year ago' : `${diffYear} years ago`;
}
